import React from "react"

/**
 * Grouped options as individual cards (e.g. criteria checkboxes: few-shot, reinforce confidence, auto-approve).
 * Each option is a rounded card with spacing; optional hints per field key.
 */
function CriteriaOptions({
  optionFields = [],
  formValues,
  onFieldChange,
  hints = {},
  title = "Options",
  subtitle,
  idPrefix = "graph-runway",
  className = "",
}) {
  if (!optionFields.length) return null

  return (
    <div className={`rounded-lg border border-gray-200 bg-white dark:bg-gray-900 shadow-sm overflow-hidden ${className}`.trim()}>
      <div className="px-4 py-3 bg-gray-50 dark:bg-gray-950 dark:bg-gray-950 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 bg-teal-500 rounded-full" />
          <span className="text-sm font-semibold text-gray-800">{title}</span>
        </div>
        {subtitle && (
          <p className="text-xs text-gray-500 mt-1 ml-3">{subtitle}</p>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 p-3">
        {optionFields.map((field) => {
          const inputKey = field.input_key || field.name
          const value = formValues[inputKey] ?? (field.default === true)
          const hint = hints[inputKey]
          return (
            <label
              key={inputKey}
              htmlFor={`${idPrefix}-${inputKey}`}
              className={`flex items-start gap-3 px-4 py-3.5 rounded-lg border bg-white dark:bg-gray-900 cursor-pointer transition-all hover:bg-teal-50/50 hover:border-teal-200 ${value ? "border-teal-300 bg-teal-50/30 ring-1 ring-teal-200" : "border-gray-200"}`}
            >
              <input
                type="checkbox"
                id={`${idPrefix}-${inputKey}`}
                checked={!!value}
                onChange={(e) => onFieldChange(inputKey, e.target.checked)}
                className="mt-0.5 h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-500 flex-shrink-0"
              />
              <span className="flex-1 min-w-0">
                <span className="text-sm font-medium text-gray-800">{field.label}</span>
                {hint && (
                  <span className="block text-xs text-gray-500 mt-0.5">{hint}</span>
                )}
              </span>
            </label>
          )
        })}
      </div>
    </div>
  )
}

export default CriteriaOptions
